const PercenDiff = (number1: number, number2: number) => {
    const difference = number2 - number1
    const percentage = (difference / number1) * 100
    return percentage
}

export default PercenDiff
